import React from 'react';
import type { CatalogItem } from '../../services/restaurantService';
import './Catalog.css';

function cuisineLabel(item: CatalogItem): string {
  return item.name || item.type || '';
}

function cuisineInitial(item: CatalogItem): string {
  const label = cuisineLabel(item);
  return label ? label.charAt(0).toUpperCase() : '?';
}

function cuisineBannerUrl(item: CatalogItem): string | undefined {
  return item.landscapeBannerUrl || item.portraitBannerUrl;
}

interface CatalogCuisineCardProps {
  item: CatalogItem;
  onClick?: () => void;
}

const CatalogCuisineCard: React.FC<CatalogCuisineCardProps> = ({ item, onClick }) => {
  const label = cuisineLabel(item);
  const banner = cuisineBannerUrl(item);

  return (
    <button type="button" className="catalog-cuisine-card" onClick={onClick} aria-label={label}>
      <div
        className={`catalog-cuisine-card__banner${banner ? '' : ' catalog-cuisine-card__banner--placeholder'}`}
        style={banner ? { backgroundImage: `url(${banner})` } : undefined}
      >
        {!banner && <span className="catalog-cuisine-card__letter">{cuisineInitial(item)}</span>}
      </div>
      <span className="catalog-cuisine-card__label">{label}</span>
    </button>
  );
};

export default CatalogCuisineCard;
